import { Injectable } from '@angular/core';
import * as Keycloak from "keycloak-js";
import {environment} from "../../../environments/environment";

@Injectable()
export class KeycloakService {

  static auth: any = {};
  static keycloak: Keycloak.KeycloakInstance = Keycloak(environment.keycloak);


  static init(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.keycloak.init({onLoad: 'login-required', checkLoginIframe: false}).success(data => {
        // console.log(this.keycloak);
        this.keycloak.loadUserInfo().success(data => {
          // console.log("userInfo");
          // console.log(data);
        });
        this.keycloak.loadUserProfile().success(data => {
          // console.log("userProfile");
          // console.log(data);
        });
        // console.log(this.keycloak.userInfo);
        resolve(data);
      }).error(error => {
        reject(error);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/keycloak.service.ts